import API from "./api";

export default {
  get: (resource, token) => API(token).get(resource),
  post: (resource, payload, token) => API(token).post(resource, payload),
  put: (resource, payload, token) => API(token).put(resource, payload),
  patch: (resource, payload, token) => API(token).patch(resource, payload),
  delete: (resource, token) => API(token).delete(resource)
};
